import { INITIAL_QUARTERS_REQUEST, FETCH_QUARTERS_SUCCESS, FINAL_QUARTERS_REQUEST } from "../../types/maintainers/quarters.type";

const initialState = {
	customers: [],
	varieties: [],
	species: [],
	quarters: [],
	estates: [],
	categories: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_varieties(state = initialState, action) {
	switch (action.type) {
		case INITIAL_QUARTERS_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_QUARTERS_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				categories: action.payload.categories,
				estates: action.payload.estates,
				species: action.payload.species,
				varieties: action.payload.varieties,
				quarters: action.payload.quarters,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_QUARTERS_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_varieties;
